module.exports = __webpack_public_path__ + "static/media/hattrick.b81f461b.jpg";